
export default {
  getName: (state) => state.name,
  getNextSeqCode: (state) => state.nextSeqCode,

  getSoils: (state) => state.soils,
}